import { action, observable, makeObservable } from 'mobx';
import axios from 'axios';

const { REACT_APP_API_URL } = process.env;

class DeleteStore {
  deleteError = null;

  constructor(profileStore) {
    makeObservable(this, {
      deleteError: observable,
      deleteAccount: action,
      clearGlobalError: action,
      deleteAccountError: action.bound
    });

    this.profileStore = profileStore;
  }

  validateDelete(values, t) {
    this.clearGlobalError();

    const errors = {};

    if (!values.currentPassword) {
      errors.currentPassword = t('currentPassword.validation');
    }

    return errors;
  }

  async deleteAccount(dataToSave, authToken) {
    try {
      await axios.post(`${REACT_APP_API_URL}/me/delete`, dataToSave, {
        headers: { Authorization: `Bearer ${authToken}` },
      });
      try {
        this.profileStore.rootStore.sendDeleteNotification();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('Failed delete notification');
      }

      return true;
    } catch (error) {
      this.deleteAccountError(error);
      return false;
    }
  }

  clearGlobalError() {
    this.deleteError = null;
  }

  deleteAccountError(error) {
    this.deleteError = error;
  }
}

export default DeleteStore;
